<style>
.stickyTab .ivu-tabs > .ivu-tabs-bar {
  margin-bottom: 0;
}
</style>

<style scoped>
.user-avatar{
  cursor: pointer;
  height: 60px;
  width: 60px;
  background: #d8d8d8;
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.arrow-left {
  left: 15px;
  z-index: 99;
  top: 20px;
  color: #000;
  font-size: 1.5em;
  position: fixed;
}
</style>

<template>
    <AppLayout class="profile-page-template">
        <!-- <Icon type="chevron-left" class="arrow-left" v-if="showProfileSettings" v-on:click="showProfileSettings = false"></Icon> -->
        <Row type="flex" justify="center">
            <Col :span="24">
                <Card shadow :padding="0" :style="{borderRadius: '0'}">
                    <Row type="flex" justify="center">
                        <Col :span="6" style="padding:15px">
                            <div @click="showVuerSingle($event,'imgViewer', true)" class="user-avatar" :style="{'backgroundColor': 'white','border':'1px solid #ddd' , 'borderRadius': '100%', 'background-image': 'url(' + userDisplayImage(profileInfo) + ')'}"></div>
                            <img v-show="false" ref="imgViewer" :src="profileInfo.avatar" width="100%" alt="IMAGE">
                        </Col>
                        <Col :span="16" style="padding:15px 15px 15px 0">
                            <p><b>{{profileInfo.display_name}}</b></p>
                            <small style="color:#aaa"><router-link :to="'profile/'+profileInfo.id">View Public Profile</router-link></small>
                        </Col>
                        <Col :span="2" style="padding: 15px 15px 15px 0">
                          <router-link to="/settings" tag="div">
                            <img :src="pencil" style="float: right;font-size: 1.3em;height: 30px;"/>
                            <!-- <Icon type="edit" style="float: right;font-size: 1.3em;" v-if="!showProfileSettings" v-on:click="showProfileSettings = true"></Icon> -->
                            <!-- <Icon type="close" style="float: right;font-size: 1.3em;" v-if="showProfileSettings" v-on:click="showProfileSettings = false"></Icon> -->
                            <!-- <Button type="text" style="position: absolute;right: 85px;" v-if="showProfileSettings" v-on:click="showProfileSettings = false">Cancel</Button> -->
                            <!-- <Button type="primary" style="position: absolute;right: 14px;" v-if="showProfileSettings" v-on:click="updateUserInfo" :disabled="disableSaveButton" :loading="updateLoader">Save</Button> -->
                          </router-link>
                          <!-- <Icon type="ios-gear-outline" style="float: right;font-size: 1.3em;"></Icon> -->
                        </Col>
                    </Row>
                </Card>
                <Row type="flex" justify="center">
                    <Col :span="24">
                        <Affix :offset-top="offsetNo" @on-change="change" v-if="!showProfileSettings">
                           <transition name="mfade">
                              <div class="stickyTab" v-if="stickTabs" style="background:#fff">
                                 <Tabs :animated="false" style="margin:0" v-model="tabName" v-on:on-click="onTabClick">
                                    <!-- <TabPane label="Profile" name="profile"></TabPane> -->
                                    <TabPane label="Timeline" name="journal"></TabPane>
                                    <TabPane label="Bookmarks" name="bookmark"></TabPane>
                                    <!-- <TabPane label="My Stuff" name="stuff"></TabPane> -->
                                 </Tabs>
                              </div>
                           </transition>
                        </Affix>
                        <Tabs :animated="false" v-model="tabName" v-on:on-click="onTabClick" v-if="!showProfileSettings">
                             <!-- <TabPane label="Profile" name="profile">
                                <ProfileInfoComponent></ProfileInfoComponent>
                            </TabPane> -->
                            <TabPane label="Timeline" name="journal">
                                <PostActivity view="journal" style="margin-bottom:10px" :page-data="profileInfo"></PostActivity>
                                <FeedList :section="'journal'" :profile="true"></FeedList>
                            </TabPane>
                            <TabPane label="Bookmarks" name="bookmark">
                                <BookmarkComponent></BookmarkComponent>
                            </TabPane>
                            <!-- <TabPane label="My Stuff" name="stuff">
                                <ResourceListItemComponent></ResourceListItemComponent>
                            </TabPane> -->

                        </Tabs>
                        <ProfileInfoComponent v-if="showProfileSettings" @onSaveData="onSave" @imageChanged="changeImage"></ProfileInfoComponent>
                    </Col>
                </Row>
            </Col>
        </Row>
    </AppLayout>
</template>

<script>
import Utils from '@/utils.js'
import FeedList from "@/components/FeedListComponent";
import PostActivity from "@/components/PostActivityComponent";
import ResourceListItemComponent from "@/components/ResourceListItemComponent";
import ProfileInfoComponent from "@/components/ProfileInfoComponent";
import BookmarkComponent from "@/components/BookmarkComponent";
import WindowScrollEvent from "vue-scroll-event/mixins/WindowOnScroll";
import VuerMixin from '@/helpers/vuerMixin'
import Vue from 'vue'

export default {
  name: "ProfileComponent",
  mixins: [WindowScrollEvent, VuerMixin],
  components: {
    FeedList,
    PostActivity,
    ResourceListItemComponent,
    ProfileInfoComponent,
    BookmarkComponent,
  },
  created() {
    if (this.$route.query.tab) {
      this.tabName = this.$route.query.tab
    }
  },
  watch: {
    $route: function(n, o) {
      if (n) this.setTab(n);
    }
  },
  computed: {
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    userBookmarks: {
      get() {
        return this.$store.state.user.userBookmarks;
      }
    },
    userStuffs: {
      get() {
        return this.$store.state.user.userStuffs;
      }
    },
    isLoadingLoadMore: {
      get() {
        return this.$store.state.user.isLoadingLoadMore;
      }
    },
    profileInfo() {
      return this.$store.state.user.info;
    },
    updateLoader() {
      return this.$store.state.user.isLoadingUserProfile;
    },
    postImageFile: {
      get() {
        return this.$store.state.publicModule.uploadedImage;
      }
    },
    pencil: {
      get() {
        return require('@/assets/pencil.png')
      }
    }
  },
  methods: {
    change(status) {
      this.stickTabs = status;
    },
    setTab(n) {
      if ("tab" in n.query && n.query.tab) {
        this.tabName = n.query.tab;
        if( this.tabName == 'bookmark') {
          this.$store.dispatch('user/getUserBookmarks')
        } else if( this.tabName == 'journal') {
          this.$store.dispatch('user/getJournalFeed')
        }
      }
      else {
        this.$router.replace({ query: { tab: "journal" } });
      }
    },
    onTabClick(name) {
      this.$router.replace({ query: { tab: name } });
    },
    onWindowScrolledBottom() {
      if (this.$route.query.tab == "bookmark") {
        if (!this.isLoadingLoadMore) {
          if (this.userBookmarks.next_link)
            this.$store.dispatch("user/loadMore", {
              link: this.userBookmarks.next_link,
              type: "bookmark"
            });
        }
      } else if (this.$route.query.tab == "stuff") {console.log('test')
        if (!this.isLoadingLoadMore) {
          if (this.userStuffs.next_link)
            this.$store.dispatch("user/loadMore", {
              link: this.userStuffs.next_link,
              type: "stuffs"
            });
        }
      }
    },
    onSave(data){
      if(data.slug == 'display_name'){
        if(data.value == ''){
          this.disableSaveButton = true;
          return false
        }
      }
      this.triggeredFields[data.slug] = data.value;
      this.disableSaveButton = false;
    },
    updateUserInfo() {
      if (this.image.changed) {
        let image = this.image.newImage;
        this.$store
        .dispatch("publicModule/uploadBase64Image", { base64_image: image })
        .then(res => {
          if (!_.isEmpty(this.postImageFile))
            this.$store
              .dispatch("user/updateUserAvatar", {
                avatar: this.postImageFile.uploaded[0]
              })
              .then(res => {
                this.image.changed = false
                this.$store.commit("user/updateUserAvatar", image);
              });
        });
      }

      let val = {
        id: this.profileInfo.id,
        data: this.triggeredFields
      };
      this.$store.dispatch("user/updateUserInfo", val).then(response => {
        this.disableSaveButton = true;
        this.$Message({
          closable: true,
          durationInSec:10,
          title: { content:'Updated' },
          icon: 'checkmark',
          message: { content: 'Profile info updated' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });             
      });
    },
    changeImage(image){
      this.image.changed = true
      this.image.newImage = image[0]
      this.disableSaveButton = false
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    }
  },
  data() {
    return {
      offsetNo: 85,
      tabName: "journal",
      stickTabs: false,
      showProfileSettings: false,
      triggeredFields: {},
      disableSaveButton: true,
      image: {
        changed: false,
        oldImage: '',
        newImage: '',
      },
    };
  },
  mounted() {
    this.$router.replace('/profile/'+this.profileInfo.id);

    setTimeout(() => {
      this.setTab(this.$route);
    }, 1000)

    if ( "type" in this.$store.state.mobileView && this.$store.state.mobileView.type === "android" )
      this.offsetNo = 0;
    if ( "type" in this.$store.state.mobileView && this.$store.state.mobileView.type === "ios" )
      this.offsetNo = 0;
  }
};
</script>
